import styles from "./PageNotFound.module.css";
import notFoundImage from "../../assets/images/404.webp";
import WhiteLogo from "../../assets/images/whitelogo.webp";
import Rocket from "../../assets/images/rocket.svg";
import Earth from "../../assets/images/earth.svg";
import Moon from "../../assets/images/moon.svg";
import Astronaut from "../../assets/images/astronaut.svg";
import { Link } from "react-router-dom";
import BgPurple from "../../assets/images/bg_purple.webp";
import classNames from "classnames";
import { saveMegaMenu } from "../../features/MegaMenu/MegaMenuSlice";
import stars from "../../assets/images/overlay_stars.svg";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const PageNotFound = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveMegaMenu(false));
  }, []);

  return (
    <div
      className={styles["bg-purple"]}
      style={{ backgroundImage: `url(${BgPurple})` }}
    >
      <div
        className={styles.stars}
        style={{ backgroundImage: `url(${stars})` }}
      >
        <div className={styles["central-body"]}>
          <img className={styles["image-404"]} src={WhiteLogo} />
          <br />
          <img
            className={classNames(styles["image-404"], "mt-5")}
            src={notFoundImage}
            width="300px"
          />
          <Link to={"/"} className={styles["btn-go-home"]} target="_blank">
            GO BACK HOME
          </Link>
        </div>
        <div className={styles.objects}>
          <img className={styles["object_rocket"]} src={Rocket} width="40px" />
          <div className={styles["earth-moon"]}>
            <img className={styles["object_earth"]} src={Earth} width="100px" />
            <img className={styles.object_moon} src={Moon} width="80px" />
          </div>
          <div className={styles.box_astronaut}>
            <img
              className={styles.object_astronaut}
              src={Astronaut}
              width="140px"
            />
          </div>
        </div>

        <div className={styles.glowing_stars}>
          <div className={styles.star}></div>
          <div className={styles.star}></div>
          <div className={styles.star}></div>
          <div className={styles.star}></div>
          <div className={styles.star}></div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
